import { Route } from '@angular/router';
import { ChannelDetailsComponent } from 'src/app/pages/network/channel-details/channel-details.component';
import { ChannelDevicesComponent } from 'src/app/pages/network/channel-details/channel-devices/channel-devices.component';
import { ChannelMarkerComponent } from 'src/app/pages/network/channel-details/channel-marker/channel-marker.component';
import { ChannelOverviewComponent } from 'src/app/pages/network/channel-details/channel-overview/channel-overview.component';
import { ChannelsComponent } from 'src/app/pages/network/channels/channels.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const channels: Route = {
  path: 'channels',
  title: 'nav.network.channels',
  data: {
    breadcrumb: 'nav.network.channels',
    icon: SbIcons.stele,
    id: RoutingID.channels,
  },
  children: [
    {
      path: '',
      component: ChannelsComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'channel-details/:channelID',
      title: 'nav.network.channels.details',
      data: {
        breadcrumb: 'nav.network.channels.details',
        icon: SbIcons.details,
        id: RoutingID.channelDetails,
      },
      children: [
        {
          path: '',
          component: ChannelDetailsComponent,
          data: {
            breadcrumb: '',
          },
          children: [
            {
              path: 'channel-details-overview',
              component: ChannelOverviewComponent,
              title: 'nav.network.channels.details.overview',
              data: {
                breadcrumb: 'nav.network.channels.details.overview',
                icon: SbIcons.eye,
                id: RoutingID.channelDetailsOverview,
              },
            },
            {
              path: 'channel-details-marker',
              component: ChannelMarkerComponent,
              title: 'nav.network.channels.details.marker',
              data: {
                breadcrumb: 'nav.network.channels.details.marker',
                icon: SbIcons.screen,
                id: RoutingID.channelDetailsMarker,
              },
            },
            {
              path: 'channel-details-devices',
              component: ChannelDevicesComponent,
              title: 'lang.globals.devices',
              data: {
                breadcrumb: 'lang.globals.devices',
                icon: SbIcons.playerOnline,
                id: RoutingID.channelDetailsDevices,
              },
            },
            {
              path: '',
              redirectTo: RoutingID.channelDetailsOverview,
              pathMatch: 'full',
            },
          ],
        },
      ],
    },
  ],
};
